import { backendClient } from "@/lib/backendClient";
import { uploadAsset } from "@/lib/uploadAsset";
import type {
    SunProtectionOrderRole,
    SunProtectionProductInput,
} from "../order.types";
import SAVE_SUN_PROTECTION_ORDER from "../graphql/SaveSunProtectionOrder.graphql";

export type SaveOrderPayload = {
    dealId: number;
    productInputs: SunProtectionProductInput[];
    signatureDataUrl?: string;
    discountCode?: string;
    role: SunProtectionOrderRole;
};

export type SaveOrderResult = {
    orderId: string;
    signatureUrl: string;
};

type SaveSunProtectionOrderResponse = {
    saveSunProtectionOrder: { id: string };
};

export async function saveOrder(
    payload: SaveOrderPayload,
): Promise<SaveOrderResult> {
    let signatureId: string | null = null;
    let signatureUrl = "";
    if (payload.signatureDataUrl) {
        const blob = await fetch(payload.signatureDataUrl).then((r) =>
            r.blob(),
        );
        const uploaded = await uploadAsset(blob, "signature.png");
        signatureId = uploaded.id;
        signatureUrl = uploaded.url;
    }
    const { data } = await backendClient.mutate<SaveSunProtectionOrderResponse>(
        {
            mutation: SAVE_SUN_PROTECTION_ORDER,
            variables: {
                dealId: payload.dealId,
                productInputs: payload.productInputs,
                signatureId,
                discountCode: payload.discountCode ?? null,
                role: payload.role,
            },
        },
    );
    const orderId = data?.saveSunProtectionOrder?.id;
    if (!orderId) {
        throw new Error("saveSunProtectionOrder returned no id");
    }
    return { orderId, signatureUrl };
}
